export interface Language {
    id: string
    title: string
    flag: string
}

export const SUPPORTED_LANGUAGES: Language[] = [
    { id: 'en', title: 'English', flag: '🇬🇧' },
    { id: 'sv', title: 'Swedish', flag: '🇸🇪' },
]

export const DEFAULT_LANGUAGE = 'en'

// Get array of language IDs for middleware and other uses
export const LOCALE_IDS = SUPPORTED_LANGUAGES.map(lang => lang.id)

// For documentInternationalization plugin
export const DOCUMENT_INTERNATIONALIZATION_LANGUAGES = SUPPORTED_LANGUAGES.map(lang => ({
    id: lang.id,
    title: lang.title,
}))

// For Sanity field options
export const LANGUAGE_OPTIONS = SUPPORTED_LANGUAGES.map(lang => ({
    title: lang.title,
    value: lang.id,
}))

// Helper function to get language flag
export function getLanguageFlag(languageId: string): string {
    const language = SUPPORTED_LANGUAGES.find(lang => lang.id === languageId)
    return language?.flag || ''
}

// Helper function to get language title
export function getLanguageTitle(languageId: string): string {
    const language = SUPPORTED_LANGUAGES.find(lang => lang.id === languageId)
    return language?.title || languageId.toUpperCase()
}

// Helper function to check if a language is supported
export function isValidLanguage(languageId: string): boolean {
    return SUPPORTED_LANGUAGES.some(lang => lang.id === languageId)
} 